module.exports = __webpack_public_path__ + "img/mobi_P6.ebad3a41.png";